// Extracts the two years from an academic-year string like "2020/2021" and returns them as an array
export const parseAcademicYearString = (yearStr: string): string[] => {
  return yearStr.split("-").map((y) => y.trim());
};
